import type { Slug } from "../lib/candidates.ts";

// Image assets served by the /assets/:file route (see main.tsx). Candidate
// portraits are keyed by the canonical slug; avatars by kind.
export type AvatarKind = "male" | "female";

export const AVATAR_KINDS: readonly AvatarKind[] = ["male", "female"];

export const candidateImage = (slug: Slug): string => `/assets/${slug}.png`;

export const avatarImage = (kind: AvatarKind): string =>
  `/assets/avatar-${kind}.png`;
